import { Box, Flex, NumberInput, RangeSlider, Text } from '@mantine/core';
import { Filter } from './Filters';
import useValidatedSearchParams from '../../../../router/useValidatedSearchParams';

const DEFAULT_MIN = 0;
const DEFAULT_MAX = 10_000;

const NumberRange = <T,>({ filter }: { filter: Filter<T> }) => {
  const { setValidatedParam, validatedParams } = useValidatedSearchParams();

  const [min = filter?.range?.min ?? 0, max = filter?.range?.max] =
    validatedParams[filter.key]?.split(',') ?? [];

  const handleSliderChange = (value: number[]) => {
    const newParams = value.join(',') || null;

    setValidatedParam(filter.key, newParams);
  };

  const handleMinChange = (value: string | number) => {
    const newMax = Number(value) > Number(max) ? value : Number(max);
    const newParams = [value.toString(), newMax].join(',');

    setValidatedParam(filter.key, newParams);
  };

  const handleMaxChange = (value: string | number) => {
    const newMin = Number(value) < Number(min) ? value : Number(min);
    const newParams = [newMin.toString(), value.toString()].join(',');

    setValidatedParam(filter.key, newParams);
  };

  const disabled = !filter?.range?.min && !filter?.range?.max;

  const numberInputProps = {
    min: Number(filter?.range?.min ?? DEFAULT_MIN),
    max: Number(filter?.range?.max ?? DEFAULT_MAX),
    suffix: filter?.suffix,
    disabled,
    size: 'md',
    hideControls: true,
    style: { flex: 1 },
  };

  return (
    <Box display="grid" style={{ gridGap: 8 }}>
      <RangeSlider
        min={Number(filter?.range?.min ?? DEFAULT_MIN)}
        max={Number(filter?.range?.max ?? DEFAULT_MAX)}
        value={[Number(min), Number(max)]}
        onChange={handleSliderChange}
        size="sm"
        disabled={disabled}
      />
      <Flex gap="xs" align="end">
        <NumberInput
          {...numberInputProps}
          label={
            <Text size="lg" mb={8}>
              {filter.minLabel}
            </Text>
          }
          value={Number(min)}
          onChange={handleMinChange}
        />
        <Text size="sm" pb={8}>
          -
        </Text>
        <NumberInput
          {...numberInputProps}
          label={
            <Text size="lg" mb={8}>
              {filter.maxLabel}
            </Text>
          }
          suffix={filter?.suffix}
          value={Number(max)}
          onChange={handleMaxChange}
        />
      </Flex>
    </Box>
  );
};

export default NumberRange;
